import {combineReducers} from 'redux'
import drafts from './drafts'
import misc from './setup_misc'

export default combineReducers({
  drafts,
  misc,
})
